import { Link, useLocation } from "react-router-dom";
import { useState, useEffect } from "react";
import "./Header.css";

function Header() {

  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > window.innerHeight - 100);
    };
    window.addEventListener("scroll", handleScroll);
  }, []);

  return (
    <header className={`fixed w-full z-50 transition-all duration-500 ${
      scrolled
        ? "bg-white/80 backdrop-blur-lg shadow-md"
        : "bg-black/40 backdrop-blur-sm"
    }`}>

      <div className="max-w-7xl mx-auto px-6 py-5 flex justify-between items-center">

        <Link
          to="/"
          className={`text-4xl font-bold tracking-wide flex items-center gap-1 logo-great ${
            scrolled ? "text-luxury-dark" : "text-white"
          }`}
        >
          <span className="logo-my">My</span>
          <span className="logo-trip">Trip</span>
        </Link>

        {/* Desktop Menu */}
        <nav className="hidden md:flex space-x-10 font-medium">

          {["Home", "About", "Hotels", "Restaurants", "Contact"].map((item, i) => {
            const path = item === "Home" ? "/" : `/${item.toLowerCase()}`;
            return (
              <Link
                key={i}
                to={path}
                className={`relative transition duration-300 menu-link ${
                  scrolled
                    ? "text-gray-800 hover:text-luxury-gold"
                    : "text-white hover:text-luxury-gold drop-shadow-md"
                } ${location.pathname === path ? 'active' : ''}`}
              >
                {item}
              </Link>
            );
          })}

        </nav>

        {/* Mobile Button */}
        <button
          onClick={() => setOpen(!open)}
          className={`md:hidden text-2xl ${
            scrolled ? "text-gray-800" : "text-white"
          }`}
        >
          ☰
        </button>

      </div>

      {/* Mobile Menu */}
      {open && (
        <div className="md:hidden bg-white shadow-lg px-6 py-4 space-y-4">
          <Link to="/" className={location.pathname === '/' ? 'font-semibold' : ''}>Home</Link>
          <Link to="/about" className={location.pathname === '/about' ? 'font-semibold' : ''}>About</Link>
          <Link to="/hotels" className={location.pathname === '/hotels' ? 'font-semibold' : ''}>Hotels</Link>
          <Link to="/restaurants" className={location.pathname === '/restaurants' ? 'font-semibold' : ''}>Restaurants</Link>
          <Link to="/contact" className={location.pathname === '/contact' ? 'font-semibold' : ''}>Contact</Link>
        </div>
      )}

    </header>
  );
}

export default Header;
